import { useState } from "react";
import { useTranslation } from "react-i18next";
import QrCodeScanner from "../components/QrCodeScanner/QrCodeScanner";
import Frame from "../components/Frame";
import { Stack, Typography } from "@mui/material";
import FeedbackOverlay from "../components/FeedbackOverlay";
import { BASE_URL } from "../consts";

export default function Riddle({ riddle, step, finishedRiddle }) {
    const { t } = useTranslation();
    const [showQr, setShowQr] = useState(false);
    const [scanErr, setScanErr] = useState(false);

    const handleScan = (data) => {
        if (data && data === `${BASE_URL}${riddle.qrCode}`) {
            finishedRiddle();
        } else {
            setScanErr(true)
            setShowQr(false);
        }
    };

    return (
        <>
            <Frame
                step={step}
                btn={{
                    title: showQr
                        ? t('STOP_SCANNER')
                        : t('SCAN_QR'),

                    onClick: () =>
                        scanErr
                            ? setScanErr(false)
                            : setShowQr(prev => !prev)
                }}
            >
                {showQr
                    ? <QrCodeScanner style={{ width: '100%', height: '100%' }}
                        onScanSuccess={(decodedText) => handleScan(decodedText)}
                    />
                    : <Stack
                        justifyContent={'space-between'}
                        height={'100%'}
                    >
                        <Typography color="white">
                            {riddle.riddle}
                        </Typography>

                        <Typography color="#00ff00">
                            {t('RIDDLE_HINT')}
                        </Typography>
                    </Stack>
                }
            </ Frame>

            <FeedbackOverlay
                isOpen={scanErr}
                setIsOpen={setScanErr}
                message={scanErr ? t('WRONG_QR') : t('WRONG_QR')}
                isSuccess={!scanErr}
            />
        </>
    );
}
